import { completeBookingsPages } from './complete-bookings-pages';
import { EditorSDK, EditorReadyOptions } from '@wix/platform-editor-sdk';
import { EditorScriptApi } from '../../api/api';
import { Translations } from '../translations';
import { closeBar, openBar, setBarStep } from '../progressbar-utils';

export type CompleteInstallationAction = {
  appToken: string;
  editorSdk: EditorSDK;
  editorScriptApi: EditorScriptApi;
  isBookingsOnEcom: boolean;
  instance: string;
  editorOptions: EditorReadyOptions;
  displayStepsBar?: {
    editorTranslation: Translations;
  };
};

export const completeInstallationAction = async ({
  appToken,
  editorSdk,
  editorScriptApi,
  isBookingsOnEcom,
  instance,
  editorOptions,
  displayStepsBar,
}: CompleteInstallationAction) => {
  try {
    if (displayStepsBar) {
      await openBar(
        editorSdk,
        appToken,
        displayStepsBar.editorTranslation,
        'bookings-migration.progress-bar.title',
        6,
      );

      await setBarStep(
        editorSdk,
        appToken,
        displayStepsBar.editorTranslation,
        'ecom-page-migration.progress-bar.initial',
        0,
      );
    }

    await editorSdk.document.transactions.runAndWaitForApproval(
      appToken,
      async () => {
        if (isBookingsOnEcom) {
          await completeBookingsPages({
            editorSDK: editorSdk,
            appToken,
            editorScriptApi,
            instance,
            editorOptions,
            ...(displayStepsBar
              ? {
                  displayStepsBar: {
                    editorTranslation: displayStepsBar?.editorTranslation,
                    currentStep: 1,
                  },
                }
              : {}),
          });
        }
      },
    );

    if (displayStepsBar) {
      await closeBar(editorSdk, appToken);
    }
  } catch (e) {
    const errorMessage = `${
      e?.message ? e.message : JSON.stringify(e)
    } - errorCode: COMPLETE_INSTALLATION_ACTION`;

    if (displayStepsBar) {
      await closeBar(editorSdk, appToken);
    }

    throw new Error(errorMessage);
  }
};
